export const environment = {
  production: true,
  servidorHttp:"https://srvrodriguez.orionsi.ar:8443/api/",
  version:"1.0",
  debug: true,
  type: 'dev',
  
};
